import React from 'react'
import style from './PastBookings.module.scss'
import CommonModal from '../../Components/Modal/Modal'
import { Bookings } from '../../types/api.types'

interface BookingDetailsModalProps {
  selectedBooking: Bookings
  handleCloseModal: () => void
  searchParams: URLSearchParams
  loadingVehicles: boolean
  getVehicleName: (vehicleId: string) => string
  formatDate: (date: string) => string
  formatTime: (date: string) => string
}

const BookingDetailsModal: React.FC<BookingDetailsModalProps> = ({
  selectedBooking,
  handleCloseModal,
  searchParams,
  loadingVehicles,
  getVehicleName,
  formatDate,
  formatTime,
}) => {
  return (
    <CommonModal
      open={!!selectedBooking}
      onCloseModal={handleCloseModal}
      title="Booking Details"
      modalWidth="600px"
    >
      <div className={style.bookingDetails}>
        {searchParams.get('bookingId') && (
          <div className={style.confirmationBanner}>
            <div className={style.confirmationIcon}>✓</div>
            <div className={style.confirmationContent}>
              <h3 className={style.confirmationTitle}>Booking Confirmed</h3>
              <p className={style.confirmationMessage}>
                Your reservation has been successfully confirmed. We look forward to serving you.
              </p>
            </div>
          </div>
        )}
        <table className={style.detailsTable}>
          <tbody>
            <tr>
              <td className={style.label}>Booking ID</td>
              <td className={style.value}>{selectedBooking.displayId}</td>
            </tr>
            <tr>
              <td className={style.label}>Status</td>
              <td className={style.value}>
                <span className={style.statusBadge}>{selectedBooking.paymentStatus}</span>
              </td>
            </tr>
            {/* <tr>
                  <td className={style.label}>Booking Status</td>
                  <td className={style.value}>{selectedBooking.status}</td>
                </tr> */}
            <tr>
              <td className={style.label}>Vehicle</td>
              <td className={style.value}>
                {loadingVehicles ? 'Loading...' : getVehicleName(selectedBooking.vehicleId)}
              </td>
            </tr>
            {selectedBooking.passengerCount && (
              <tr>
                <td className={style.label}>Passengers</td>
                <td className={style.value}>{selectedBooking.passengerCount}</td>
              </tr>
            )}
            {selectedBooking.luggage && (
              <tr>
                <td className={style.label}>Luggage</td>
                <td className={style.value}>{selectedBooking.luggage}</td>
              </tr>
            )}
            {selectedBooking.pickupSign && (
              <tr>
                <td className={style.label}>Pickup Sign</td>
                <td className={style.value}>{selectedBooking.pickupSign}</td>
              </tr>
            )}
            {selectedBooking.tripSegments &&
              selectedBooking.tripSegments.map((segment, index) => (
                <>
                  {selectedBooking.tripSegments.length > 1 && (
                    <tr key={`header-${segment.id}`}>
                      <td className={style.label} colSpan={2}>
                        <strong>{index === 0 ? 'First Journey' : 'Return Journey'}</strong>
                      </td>
                    </tr>
                  )}
                  <tr key={`pickup-${segment.id}`}>
                    <td className={style.label}>Pickup Address</td>
                    <td className={style.value}>{segment.pickupAddress}</td>
                  </tr>
                  <tr key={`dropoff-${segment.id}`}>
                    <td className={style.label}>Dropoff Address</td>
                    <td className={style.value}>{segment.dropoffAddress}</td>
                  </tr>
                  <tr key={`date-${segment.id}`}>
                    <td className={style.label}>Scheduled Date</td>
                    <td className={style.value}>{formatDate(segment.scheduledAt)}</td>
                  </tr>
                  <tr key={`time-${segment.id}`}>
                    <td className={style.label}>Scheduled Time</td>
                    <td className={style.value}>{formatTime(segment.scheduledAt)}</td>
                  </tr>
                  {segment.flightName && (
                    <tr key={`flight-${segment.id}`}>
                      <td className={style.label}>Flight Name</td>
                      <td className={style.value}>{segment.flightName}</td>
                    </tr>
                  )}
                </>
              ))}
            <tr>
              <td className={style.label}>Fair</td>
              <td className={style.value}>
                <strong>€{selectedBooking.fair.toFixed(2)}</strong>
              </td>
            </tr>
            <tr>
              <td className={style.label}>Booked On</td>
              <td className={style.value}>
                {formatDate(selectedBooking.createdAt)} at {formatTime(selectedBooking.createdAt)}
              </td>
            </tr>
            {selectedBooking.bookingForSomeoneElse && (
              <>
                <tr>
                  <td className={style.label} colSpan={2}>
                    <strong>Guest Information</strong>
                  </td>
                </tr>
                {selectedBooking.guestFullName && (
                  <tr>
                    <td className={style.label}>Guest Name</td>
                    <td className={style.value}>{selectedBooking.guestFullName}</td>
                  </tr>
                )}
                {selectedBooking.guestEmail && (
                  <tr>
                    <td className={style.label}>Guest Email</td>
                    <td className={style.value}>{selectedBooking.guestEmail}</td>
                  </tr>
                )}
                {selectedBooking.guestPhoneNumber && (
                  <tr>
                    <td className={style.label}>Guest Phone</td>
                    <td className={style.value}>{selectedBooking.guestPhoneNumber}</td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
        <div className={style.contactInfo}>
          <p className={style.contactTitle}>Have questions about your booking?</p>
          <div className={style.contactDetails}>
            <div className={style.contactItem}>
              <span className={style.contactLabel}>Email:</span>
              <a href="mailto:chaufferridesltd@hotmail.com">chaufferridesltd@hotmail.com</a>
            </div>
            <div className={style.contactItem}>
              <span className={style.contactLabel}>Phone:</span>
              <a href="tel:+447943152288">+44 7943 152288</a>
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  )
}

export default BookingDetailsModal
